export const tosToc = [
  {
    id: 'overview',
    label: 'Overview',
  },
  {
    id: 'intellectual-property',
    label: 'Intellectual Property Rights',
  },
  {
    id: 'warranty',
    label: 'Warranty',
  },
  {
    id: 'indemnification',
    label: 'Indemnification',
  },
  {
    id: 'subscriptions',
    label: 'Subscriptions',
  },
  {
    id: 'user-data',
    label: 'User Datas',
  },
  {
    id: 'interruptions',
    label: 'Modifications and Interruptions',
  },
  {
    id: 'termination',
    label: 'Termination',
  },
  {
    id: 'governing-law',
    label: 'Governing Law',
  },
  {
    id: 'changes',
    label: 'Changes to This Privacy Policy',
  },
  {
    id: 'contact-us',
    label: 'Contact Us',
  },
];
